import React from 'react';
import { ThemeProvider, withTheme } from 'styled-components';
import cuid from 'cuid';
import { htmlTheme } from './theme';
// eslint-disable-next-line import/no-cycle
import Wrapper from './Wrapper';
var Html = function (_a) {
    var contentData = _a.contentData, _b = _a.componentKey, componentKey = _b === void 0 ? cuid() : _b;
    var margin = contentData.field_margin, padding = contentData.field_padding, bgColor = contentData.field_background_color, activeBorder = contentData.field_active_border, htmlContent = contentData.field_html_editor, textAlign = contentData.field_text_align;
    return (React.createElement(ThemeProvider, { theme: htmlTheme },
        React.createElement(Wrapper, { className: "cms-html-wrapper", styleMargin: margin, stylePadding: padding, styleBackgroundColor: bgColor, styleActiveBorder: activeBorder, styleTextAlign: textAlign, key: componentKey, 
            // eslint-disable-next-line react/no-danger
            // @ts-ignore
            dangerouslySetInnerHTML: { __html: htmlContent } })));
};
export default withTheme(Html);
//# sourceMappingURL=index.js.map